import { useMemo } from 'react'
import { getters } from 'helpers'
import { useBlacklist } from 'hooks'

import useAllVaults from './useAllVaults'
import useDepositsVaults from './useDepositsVaults'


type Input = VaultsPage.SortFormParams & {
  skip: number
  limit: number
}

type Output = {
  data: VaultList.Vault[]
  blacklistTotal: number
  isFetching: boolean
}

const useVaultsData = (input: Input): Output => {
  const { sort, filter, search, limit, skip } = input

  const { blacklist, isFetching: isBlackListFetching } = useBlacklist()

  const params = useMemo(() => ({
    sort, search, limit, skip, blacklist,
  }), [ sort, search, limit, skip, blacklist ])

  const { data: allData, isFetching: isAllFetching } = useAllVaults(params)
  const { data: depositsData, isFetching: isDepositsFetching } = useDepositsVaults(params)

  return useMemo(() => {
    const blacklistTotal = blacklist.length

    if (filter === 'all') {
      return {
        data: allData,
        blacklistTotal,
        isFetching: isBlackListFetching || isAllFetching,
      }
    }

    return {
      blacklistTotal,
      data: depositsData,
      isFetching: isBlackListFetching || isDepositsFetching,
    }
  }, [
    filter,
    allData,
    blacklist,
    depositsData,
    isAllFetching,
    isDepositsFetching,
    isBlackListFetching,
  ])
}


export default useVaultsData
